import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoConsultaContratoCovid: [],
    removeTipoContratoConsultaContratoCovid: [],
    removeExercicioContratoConsultaContratoCovid: [],
    removeTipoCompraConsultaContratoCovid: [],
    removeNumeroContratoConsultaContratoCovid: [],
    removeObjetoContratoConsultaContratoCovid: [],
    removeNomeContratadoContratoConsultaContratoCovid: [],
    removeSituacaoConsultaContratoCovid: [],
    removeStatusConsultaContratoCovid: [],
    setMostraAplicarFiltroConsultaContratoCovid: [],
    limpaFiltroConsultaContratoCovid: [],
    aplicarFiltroConsultaContratoCovid: ['filtro'],
})

const INITIAL_STATE = {
    administracao: [],
    tipoContrato: [],
    tipoCompra: '',
    exercicioContrato: '',
    numeroContrato: '',
    objetoContrato: '',
    nomeContratadoContrato: '',
    situacao: [],
    status: '',
    mostraAplicarFiltro: false,
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeTipoContrato = (state = INITIAL_STATE, action) => {
    state.tipoContrato.splice(state.tipoContrato.indexOf(action.tipoContrato), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.tipoContrato = Array.from(state.tipoContrato)
    return { ...state, mostraAplicarFiltro: true }
}

const removeTipoCompra = (state = INITIAL_STATE, action) => {
    return { ...state, tipoCompra: '', mostraAplicarFiltro: true }
}

const removeExercicioContrato = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioContrato: '', mostraAplicarFiltro: true }
}

const removeNumeroContrato = (state = INITIAL_STATE, action) => {
    return { ...state, numeroContrato: '', mostraAplicarFiltro: true }
}

const removeObjetoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, objetoContrato: '', mostraAplicarFiltro: true }
}

const removeNomeContratadoContrato = (state = INITIAL_STATE, action) => {
    return { ...state, nomeContratadoContrato: '', mostraAplicarFiltro: true }
}

const removeSituacao = (state = INITIAL_STATE, action) => {
    return { ...state, situacao: '', mostraAplicarFiltro: true }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_CONTRATO_COVID]: removeAdministracao,
    [Types.REMOVE_TIPO_CONTRATO_CONSULTA_CONTRATO_COVID]: removeTipoContrato,
    [Types.REMOVE_TIPO_COMPRA_CONSULTA_CONTRATO_COVID]: removeTipoCompra,
    [Types.REMOVE_EXERCICIO_CONTRATO_CONSULTA_CONTRATO_COVID]: removeExercicioContrato,
    [Types.REMOVE_NUMERO_CONTRATO_CONSULTA_CONTRATO_COVID]: removeNumeroContrato,
    [Types.REMOVE_OBJETO_CONTRATO_CONSULTA_CONTRATO_COVID]: removeObjetoContrato,
    [Types.REMOVE_NOME_CONTRATADO_CONTRATO_CONSULTA_CONTRATO_COVID]: removeNomeContratadoContrato,
    [Types.REMOVE_SITUACAO_CONSULTA_CONTRATO_COVID]: removeSituacao,
    [Types.REMOVE_STATUS_CONSULTA_CONTRATO_COVID]: removeStatus,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_CONTRATO_COVID]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_CONTRATO_COVID]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_CONTRATO_COVID]: aplicarFiltro,
})
